import React from 'react';
import { Button } from '@zillow/constellation';
import { useWizard, useWizardStep, useWizardSubStep } from '@zillow/zrs-rental-applications';
import { useId, useIsOnExitLoading } from '../contexts/IdVerificationContext';

export interface ButtonProps {
  id: string;
  disabled: boolean;
  onClick: () => void;
  currentStep: string;
  currentSubStep: string;
}

export default function NextButton() {
  const id = useId();
  const { currentStep, currentSubStep, onRequestNext, isLoading } = useWizard();
  const isOnExitLoading = useIsOnExitLoading();
  const currentStepDetails = useWizardStep({ id: currentStep, subscription: ['renderNextButton', 'isNextDisabled'] });
  const currentSubStepDetails = useWizardSubStep({
    id: currentSubStep,
    stepId: currentStep,
    subscription: ['renderNextButton', 'isNextDisabled'],
  });
  const { renderNextButton: renderNextButtonFromStep, isNextDisabled: isNextDisabledStep = false } =
    currentStepDetails?.meta ?? {};
  const { renderNextButton: renderNextButtonFromSubStep, isNextDisabled: isNextDisabledSubStep = false } =
    currentSubStepDetails?.meta ?? {};
  const buttonProps: ButtonProps = {
    id: `${id}-next-button`,
    disabled: isNextDisabledSubStep || isNextDisabledStep || isLoading || isOnExitLoading,
    onClick: onRequestNext,
    currentStep,
    currentSubStep,
  };

  const renderNextButton = renderNextButtonFromSubStep ?? renderNextButtonFromStep ?? 'Continue';

  if (!currentStep) {
    return null;
  }

  if (typeof renderNextButton === 'string') {
    return (
      <Button buttonType="primary" {...buttonProps}>
        {renderNextButton}
      </Button>
    );
  }

  if (typeof renderNextButton === 'function') {
    return renderNextButton(buttonProps);
  }

  return (
    <Button buttonType="primary" {...buttonProps}>
      Next
    </Button>
  );
}
